"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryResults = exports.questions = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var questions = [{
  prompt: "Which of these thoughts apply to you when you can’t sleep or are worried about your sleep?",
  type: "radio",
  meta: {
    answerLabel: "The thoughts that apply are: ",
    summaryTitle: "Which of these thoughts apply to you when you can’t sleep or are worried about your sleep?",
    responsePrefix: "My thoughts that apply are: ",
    noResponsePrefix: "I have none of these thoughts"
  },
  options: ["I just want this to be over", "What time is it?", "I don’t have any time until the alarm starts", "Tomorrow is going to be terrible", "I have so much to do"],
  batteryId: "RETRAINING_THINKING_SLEEP_THOUGHTS"
}, {
  prompt: "What about these?",
  type: "radio",
  meta: {
    answerLabel: "The thoughts that apply are: ",
    summaryTitle: "Which of these thoughts apply to you when you can’t sleep or are worried about your sleep?",
    responsePrefix: "My thoughts that apply are: ",
    noResponsePrefix: "I have none of these thoughts"
  },
  options: ["I can’t deal with everything if I haven’t slept well", "I’ve forgotten how to sleep", "I’ll never sleep properly again", "I will wake up my partner, child or family", "I am disturbing their sleep"],
  batteryId: "RETRAINING_THINKING_SLEEP_THOUGHTS"
}, {
  prompt: "Or these?",
  type: "radio",
  meta: {
    answerLabel: "The thoughts that apply are: ",
    summaryTitle: "Which of these thoughts apply to you when you can’t sleep or are worried about your sleep?",
    responsePrefix: "My thoughts that apply are: ",
    noResponsePrefix: "I have none of these thoughts"
  },
  options: ["I will never get back this sleep", "I hate that they can sleep so easily"],
  batteryId: "RETRAINING_THINKING_SLEEP_THOUGHTS"
}, {
  prompt: "Anything I missed?",
  type: "textarea",
  meta: {
    answerLabel: "Another thought is",
    summaryTitle: "A thought that applies when you can’t sleep or are worried about your sleep?"
  },
  batteryId: "RETRAINING_THINKING_SLEEP_THOUGHTS"
}, {
  prompt: "Why are these thoughts unhelpful? What are they costing you personally?",
  type: "radio",
  meta: {
    answerLabel: "These thoughts are unhelpful because",
    summaryTitle: "Your prediction is not 100% true because",
    responsePrefix: "These thoughts are unhelpful because: ",
    noResponsePrefix: "No thoughts are unhelpful"
  },
  options: ["Makes me angry", "Makes me frustrated", "I get distressed", "My mind starts rolling over and over"],
  batteryId: "RETRAINING_THINKING_SLEEP_THOUGHTS"
}, {
  prompt: "Any of these?",
  type: "radio",
  meta: {
    answerLabel: "These thoughts are unhelpful because",
    summaryTitle: "Your prediction is not 100% true because",
    responsePrefix: "These thoughts are unhelpful because: ",
    noResponsePrefix: "No thoughts are unhelpful"
  },
  options: ["My heart rate and breathing increase", "I feel more stressed and anxious", "I start to think of the other day that I have had bad or no sleep", "I start to think about all the things I need to do tomorrow"],
  batteryId: "RETRAINING_THINKING_SLEEP_THOUGHTS"
}, {
  prompt: "Any other costs for you personally?",
  type: "textarea",
  meta: {
    answerLabel: "Another cost is",
    summaryTitle: "Any other costs for you personally?"
  },
  batteryId: "RETRAINING_THINKING_SLEEP_THOUGHTS"
}, {
  prompt: "Why are these thoughts not 100% true?",
  type: "radio",
  meta: {
    answerLabel: "These thoughts are unhelpful because",
    summaryTitle: "Your prediction is not 100% true because",
    responsePrefix: "These thoughts are unhelpful because: ",
    noResponsePrefix: "No thoughts are unhelpful"
  },
  options: ["I have had good and bad nights of sleep last week", "I may have less sleep but I will generally get some sleep", "I have had this thought before yet most days I sleep relatively well", "I can still function without sleep"],
  batteryId: "RETRAINING_THINKING_SLEEP_THOUGHTS"
}, {
  prompt: "Any other reasons for you personally? Try to think of specific examples for when it hasn’t been true.",
  type: "textarea",
  meta: {
    answerLabel: "Other reasons are",
    summaryTitle: "Any other reasons for you personally"
  },
  batteryId: "RETRAINING_THINKING_SLEEP_THOUGHTS"
}, {
  prompt: "Okay, what can you tell yourself that will be helpful if this thought pops up again:",
  type: "radio",
  meta: {
    answerLabel: "These thoughts are unhelpful because",
    summaryTitle: "Your prediction is not 100% true because",
    responsePrefix: "These thoughts are unhelpful because: ",
    noResponsePrefix: "No thoughts are unhelpful"
  },
  options: ["Regardless of how much sleep I get I will still be able to get things done tomorrow.", "My sleep is slowly getting better", "My day is much better than I think it will be after poor sleep"],
  batteryId: "RETRAINING_THINKING_SLEEP_THOUGHTS"
}, {
  prompt: "Anything personal that would help you?",
  type: "textarea",
  meta: {
    answerLabel: "Other reasons are",
    summaryTitle: "Any other reasons for you personally"
  },
  batteryId: "RETRAINING_THINKING_SLEEP_THOUGHTS"
}];
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    if (!question.hideFromSummary && answers[question.batteryId][index]) {
      if (question.type === "radio") {
        return {
          question: question,
          answer: question.options[answers[question.batteryId][index]]
        };
      } else {
        return {
          question: question,
          answer: answers[question.batteryId][index]
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;